import { render } from "./slidesheet-18.vue?vue&type=template&id=d2f7718a&scoped=true"
import script from "./slidesheet-18.vue?vue&type=script&lang=js"
export * from "./slidesheet-18.vue?vue&type=script&lang=js"

import "./slidesheet-18.vue?vue&type=style&index=0&id=d2f7718a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f7718a"]])

export default __exports__